import {fetchFootprint} from '../api/footprints';
export const LOAD_FOOTPRINT = 'LOAD_FOOTPRINT';
export const RECEIVE_FOOTPRINT = 'RECEIVE_FOOTPRINT';


export const loadFootprint = (name) => {
  return {
    type: LOAD_FOOTPRINT,
    name: name
  }
}

export const receiveFootprint = (name, data) => {
  return {
    type: RECEIVE_FOOTPRINT,
    name: name,
    data: data
  }
}

export const getFootprint = (name) => {
  return  (dispatch, getState) => {
    const footprints = getState().footprints.footprints;
    if (footprints[name]) {
      return; //Promise.resolve(footprints[name]);
    }
    var promise = fetchFootprint(name); 
    dispatch(loadFootprint(name));
    return promise.then((response) => dispatch(receiveFootprint(name, response)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/Footprints.js